const WISHLIST_KEY = "innovate.wishlist" 
checkLocalStorage() 
checkBtns()

document.addEventListener('DOMContentLoaded', ()=>{

    if (location.pathname.includes('/pages/favoritos')) {
        const productContainer = document.querySelector('.grid--collection')
        const wishlistLS = JSON.parse(localStorage.getItem(WISHLIST_KEY))

        wishlistLS.forEach(wishlistItem => renderVariants(wishlistItem, productContainer));

        document.addEventListener('click', (evt)=>{

            if (evt.target.matches('.wishlist--btn') || evt.target.closest('.wishlist--btn')) {
                evt.preventDefault()
                const itemFilled = evt.target.closest('.wishlist--btn')
                removeItemHandler(itemFilled)
                
                location.reload()
            }

        })
    }

    const [...wishlistBtnEmpty] = document.querySelectorAll('.wishlist--btn[data-state="empty"]')
    const [...wishlistBtnFilled] = document.querySelectorAll('.wishlist--btn[data-state="filled"]')

    wishlistBtnEmpty.forEach( itemEmpty => {
        
        itemEmpty.addEventListener('click',(evt)=>{
            evt.preventDefault()
            const dataHandle = itemEmpty.dataset.handle
            const [handle, variantId] = dataHandle.split('_')
            const dataLS = JSON.parse(localStorage.getItem(WISHLIST_KEY))
            
            const existHandle = dataLS.find(element => element.handle === handle)
            if (existHandle) {
              existHandle.variants.push(Number(variantId))
            }else{
              dataLS.push({
                handle,
                variants: [Number(variantId)] 
              })
            }
            
          
            localStorage.setItem(WISHLIST_KEY, JSON.stringify(dataLS))

            const relatedbtn = itemEmpty.parentElement.querySelector('.wishlist--btn[data-state="filled"]')
            relatedbtn.style.display = "block"
            itemEmpty.style.display = "none"

        })
    });

    wishlistBtnFilled.forEach( itemFilled => {
        itemFilled.addEventListener('click',(evt)=>{
            evt.preventDefault()
            removeItemHandler(itemFilled)

            const relatedbtn = itemFilled.parentElement.querySelector('.wishlist--btn[data-state="empty"]')
            relatedbtn.style.display = "block"
            itemFilled.style.display = "none"

        })
    });

})

function removeItemHandler(itemFilled) {
  const dataHandle = itemFilled.dataset.handle
  const [handle, variantId] = dataHandle.split('_')
  let dataLS = JSON.parse(localStorage.getItem(WISHLIST_KEY))

  const existHandle = dataLS.find(element => element.handle === handle)
  if (existHandle) {
    if (existHandle.variants.length == 1) {
      dataLS.splice(dataLS.indexOf(existHandle),1)
    }else{
      existHandle.variants.splice(existHandle.variants.indexOf(Number(variantId)),1)
    }
  }
  

  localStorage.setItem(WISHLIST_KEY, JSON.stringify(dataLS))
}


async function renderVariants(wishlistItem, productContainer) {
    const request = await fetch(`/products/${wishlistItem.handle}.js`)
    const product = await request.json()
    console.log(product);

    const productVariant = []
    wishlistItem.variants.forEach(variantId =>{
        const prodVariant = product.variants.find(variant => variant.id === variantId)

        if (prodVariant) {
            productVariant.push(prodVariant)
        }
    })

    productVariant.forEach(variant => {
        productContainer.insertAdjacentHTML('afterbegin',`
    
    <div class="grid__item grid__item-padding-left grid-product small--one-half medium-up--one-third aos-init aos-animate" data-aos="row-of-" data-product-handle="lz-1-screen-reading ">
    <div class="grid-product__content">
    
    <div class="container__wishlist">
        <a href="#" class="wishlist--btn" data-state="empty" data-handle="${wishlistItem.handle}_${variant.id}" style="display: none;">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
            <g id="icon-fav-circle" transform="translate(-5.613 -6.762)">
              <g id="heart" transform="translate(5.613 6.762)">
                <rect id="Rectángulo_293" data-name="Rectángulo 293" width="30" height="30" opacity="0"></rect>
                <path id="heart-2" data-name="heart" d="M19.632,4.464a5.269,5.269,0,0,0-7.293,0l-.994.964-.994-.964a5.27,5.27,0,0,0-7.293,0,4.9,4.9,0,0,0,0,7.075l.994.964,7.293,7.075L18.639,12.5l.994-.964a4.9,4.9,0,0,0,0-7.075Z" transform="translate(3.702 3.697)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
              </g>
            </g>
          </svg>                
        </a>
        <a href="#" class="wishlist--btn" data-state="filled" data-handle="${wishlistItem.handle}_${variant.id}" style="display: block;">
          <svg id="icon-favorito" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
            <g id="heart">
              <rect id="Rectángulo_293" data-name="Rectángulo 293" width="30" height="30" opacity="0"></rect>
              <path id="heart-2" data-name="heart" d="M20.84,4.61a5.5,5.5,0,0,0-7.78,0L12,5.67,10.94,4.61a5.5,5.5,0,0,0-7.78,7.78l1.06,1.06L12,21.23l7.78-7.78,1.06-1.06a5.5,5.5,0,0,0,0-7.78Z" transform="translate(3 2.886)"></path>
              <path id="heart_-_Contorno" data-name="heart - Contorno" d="M16.95,2a6.5,6.5,0,0,1,4.6,11.1l-8.84,8.84a1,1,0,0,1-1.414,0L2.453,13.1A6.5,6.5,0,0,1,11.647,3.9L12,4.256l.353-.353A6.457,6.457,0,0,1,16.95,2ZM12,19.816l8.133-8.133a4.5,4.5,0,1,0-6.366-6.366l-1.06,1.06a1,1,0,0,1-1.414,0l-1.06-1.06a4.5,4.5,0,0,0-6.366,6.366Z" transform="translate(3 2.886)"></path>
            </g>
          </svg>                              
        </a>
    </div>
    <a href="${product.url}?variant=${variant.id}" class="grid-product__link">
        <div class="grid-product__image-mask">
        <div class="image-wrap" style="height: 0; padding-bottom: 100.0%;">
              <img class="grid-product__image lazyautosizes lazyloaded" data-widths="[180, 360, 540, 720, 900, 1080]" data-aspectratio="1.0" data-sizes="auto" alt="LZ 1 Screen Reading#color_light-blue-frozen"  sizes="476px" srcset="${variant.featured_image.src}">
              <noscript>
                <img class="grid-product__image lazyloaded"
                  src="${variant.featured_image.src}"
                  alt="LZ 1 Screen Reading#color_light-blue-frozen">
              </noscript>
            </div>
          </div>

        </a><div class="grid-product__meta"><a href="${product.url}?variant=${variant.id}" class="grid-product__link">
          
          </a>
          <div class="grid-product__title grid-product__title--heading aline-favourite">
            <a href="${product.url}?variant=${variant.id}" class="grid-product__link">
            ${product.title}
            </a>
          </div>
          <div class="grid-product__price"><span class="visually-hidden">Precio habitual</span>
              <span class="grid-product__price--original">$${(variant.compare_at_price / 100).toFixed(2)}</span>
              <span class="visually-hidden">Precio de oferta</span>$${(variant.price / 100).toFixed(2)}
          </div>   
  </div>
  </div>
    
    
    `)
    })

    
}

function checkLocalStorage() {
    const wishlistLS = localStorage.getItem(WISHLIST_KEY)

    if (!wishlistLS) {
        localStorage.setItem(WISHLIST_KEY, JSON.stringify([]))
    }
}

function checkBtns() {
    const wishlistLS = JSON.parse(localStorage.getItem(WISHLIST_KEY))
    if (wishlistLS.length > 0) {
      
        wishlistLS.forEach(wishlistItem => {
            const handle = wishlistItem.handle
            
            wishlistItem.variants.forEach(variantId =>{
              const wishlistBtnEmpty = document.querySelector(`.wishlist--btn[data-state="empty"][data-handle="${handle}_${variantId}"]`)
              const wishlistBtnFilled = document.querySelector(`.wishlist--btn[data-state="filled"][data-handle="${handle}_${variantId}"]`)           
              if (wishlistBtnEmpty) wishlistBtnEmpty.style.display = "none"
              if (wishlistBtnFilled) wishlistBtnFilled.style.display = "block"                   
            })

        });
    }
}